<div *ngIf="!router.url.includes('corporate-privacy-policy')" id="blog-subscribe"
    class="section-newsletter section-ptb bg_image bg-overlay">
    <div class="container">
        <div class="row newsletter-style-2 political-newsletter align-items-center">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                <div class="title text-center">
                    <h2>Join Our Community Subscribe to Our Newsletter.</h2>
                </div>
            </div>
            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1"></div>
            <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10 mt-4">
                <form [formGroup]="subscribeForm" (ngSubmit)="submitSubForm()">
                    <div class="input-box">
                        <input type="email" placeholder="Enter Your Email* " formControlName="email"
                            class="form-control" id="email" name="a"
                            [ngClass]="{ 'is-invalid': submittedSub && getSubForm.email.errors }" />
                        <div *ngIf="submittedSub && getSubForm.email.errors" class="invalid-feedback">
                            <div style="color: #fff;" *ngIf="getSubForm.email.errors.required">* Please enter email
                                address
                            </div>
                            <div style="color: #fff;" *ngIf="getSubForm.email.errors.pattern">* Please enter valid email
                                address
                            </div>
                        </div>
                        <button style="background-color: #da2b27;" type="submit">Subscribe</button>
                    </div>
                </form>
                <p style="color: #fff">{{ subRespData?.statusDesc }}</p>
            </div>
            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1"></div>
        </div>
    </div>
    <div class="section-service section-pt bg-gray section-pb text-white">
        <div class="container">
            <div class="row">
                <div class="col-lg-3  ">
                    <img src="assets/images/logo/whitelogo.png" class="protecttailogo" alt="logo">
                    <p style="font-weight: 300" class="mobilejustify">
                        A leader in Mobile App Security in India. Your trusted partner in mobile threat defense.
                        Comprehensive Mobile App Security platform with Runtime Application Self Protection (RASP) and
                        powered by Deep Tech.
                    </p>
                    <p style="font-weight: 500" class="text-left"> Follow us <br /><a
                            href="https://www.linkedin.com/company/protectt-ai-labs-pvt-ltd/" target="_blank"><span
                                style="font-size: 20px; color: #1A3F6E"><i
                                    class="fa fa-linkedin text-white"></i></span></a></p>
                    <!-- <img class="img-fluid" width="25%" height="auto" src="assets/images/ISO-27001.png" alt="ISO-27001"> -->
                </div>

                <div class="col-lg-3 col-md-3 offset-md-1">
                    <div class="section-title">
                        <h6 class="text-white">Product for Corporates</h6>
                        <a routerLink="/appprotectt" id="links">AppProtectt</a>
                        <br />
                        <a routerLink="/appprotectt-lite" id="links">AppProtectt Lite</a>
                        <br />
                        <a routerLink="/appbind" id="links">AppBind</a>
                        <br />
                        <a routerLink="/mprotectt-biz-plus" id="links">MProtectt Biz+</a>
                        <br />
                        <a routerLink="/realtime-protectt" id="links">RealTime Protectt</a>
                        <br />
                        <a routerLink="/platform" id="links">Platform</a>
                    </div>

                    <div class="section-title">
                        <h6 class="text-white">Product for Individuals</h6>
                        <a routerLink="/mprotectt" id="links">About Mobile Security</a>
                        <br />
                        <a routerLink="mprotectt/ios" id="links">iOS</a>
                        <br />
                        <a routerLink="mprotectt/android" id="links">Android</a>
                    </div>
                </div>

                <div class="col-lg-2 col-md-2">
                    <div class="section-title">
                        <h6 class="text-white">Get Started</h6>
                        <a href="#" id="links">Home</a>
                        <br />
                        <a routerLink="/about-us" id="links">About Us</a>
                        <br />
                        <a routerLink="/platform" id="links">Platform</a>
                        <br />
                        <a routerLink="/blogs" id="links">Blogs</a>
                        <br />
                        <a routerLink="/industry-news" id="links">Industry News</a><br />
                        <a routerLink="/community" id="links">Community</a><br />
                        <a routerLink="/careers" id="links">Careers</a><br />
                    </div>
                </div>

                <div class="col-lg-3 col-md-3  ">
                    <div class="section-title">
                        <h6 class="text-white">Cyber Security Solution</h6>
                        <a routerLink="/rasp" id="links">Runtime Application Self Protection</a><br />
                        <a routerLink="/mobile-device-security" id="links">Mobile Device Security</a><br />
                        <a routerLink="/rbi-digital-payment-security-control-solution" id="links">Digital
                            Payment Security Control</a>
                        <a routerLink="/frm" id="links">Fraud & Risk Management</a><br />
                        <a routerLink="/byod" id="links">Bring your own device</a><br />
                        <a routerLink="/cyber-lab-services" id="links">Cyber Lab Services</a><br />
                    </div>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-lg-12 responsiveleft">
                    <pre></pre>
                    <img class="img-fluid" width="5%" height="auto" style="padding-right: 16px"
                        src="assets/images/ISO-27001.png" alt="ISO-27001">
                    <strong>© Protectt <sup>TM</sup>, Protectt.ai<sup>TM</sup>, Real Time
                        Protectt<sup>TM</sup>, MProtectt<sup>TM</sup>, AppProtectt<sup>TM</sup>
                        are registered trademarks of Protectt.ai Private Ltd.</strong>
                    <br />
                    <pre></pre>
                    <ul>
                        <li><a *ngIf="!router.url.includes('corporate-privacy-policy')"
                                routerLink="/corporate-privacy-policy" class="pr-4">Corporate Privacy Policy</a>
                        </li>
                        <li style="float: left;"><a *ngIf="router.url.includes('mprotectt')"
                                href="https://protectt.ai/ProtecttGateway/privacyPolicy" target="_blank" id="links"
                                class="pr-4">MProtectt
                                App Privacy Policy</a></li>
                        <li style="float: left;"><a *ngIf="router.url.includes('mprotectt')"
                                href="https://protectt.ai/ProtecttGateway/termcondition" target="_blank" id="links"
                                class="pr-4">MProtectt
                                App Terms & Conditions</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="sticky-social"
    *ngIf="routerpath != '/appprotecttmobileappsecurity' && routerpath != '/appbindzerotrustdevice'">
    <ul class="social">
        <li class="linkedin"><a target="_blank" href="https://www.linkedin.com/company/protectt-ai-labs-pvt-ltd/"><i
                    class="fa fa-linkedin" aria-hidden="true"></i></a></li>
    </ul>
</div>

<div class="sticky-social1" *ngIf="routerpath != '/appprotecttmobileappsecurity'">
    <ul class="social">
        <li class="contactus" data-toggle="modal" data-target="#footermodalContactForm">
            <a>
                <i class="fa fa-phone" aria-hidden="true"></i>
            </a>
            <span class="ml-3 sidetitle">Contact Us</span>
        </li>
    </ul>
</div>

<div class="sticky-socialrequest"
    *ngIf="routerpath == '/appprotecttmobileappsecurity' || routerpath == '/appbindzerotrustdevice'">
    <ul class="social">
        <li class="joincommunity" (click)="goto()">
            <a>
                <i class="fa fa-envelope-o" aria-hidden="true"></i>
            </a>
            <span class="ml-3 sidetitle">Request A Demo</span>
        </li>
    </ul>
</div>

<div class="modal fade" id="footermodalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content border-radius-15">
            <div style="background: #163e6f" class="p-2 border-radius-10-10-0-0">
                <button type="button" class="close contact-us" data-dismiss="modal" aria-label="Close" #closebutton>
                    <span style="color: #fff" aria-hidden="true">&times;</span>
                </button>
                <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
                    Contact Us
                </h4>
            </div>
            <div class="modal-body mx-3 pb-0 modal-bg">
                <div class="row">
                    <div class="mx-auto">
                        <table class="table table-borderless w-50 table-contact">
                            <tr>
                                <td class="text-center"><strong><i class="fa fa-envelope-o text-dark"></i></strong></td>
                                <td><a href="mailto:sales@protectt.ai" class="cursor-pointer">sales@protectt.ai</a></td>
                            </tr>
                            <tr>
                                <td class="text-center"><strong><i class="fa fa-mobile text-dark"></i></strong></td>
                                <td class="d-none d-md-table-cell">8850106650</td>
                                <td class="d-table-cell d-md-none"><a href="tel:8850106650"
                                        class="cursor-pointer">8850106650</a></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <!-- <div class="modal-footer d-flex justify-content-center border-radius-0-0-10-10">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                    Close
                </button>
            </div> -->
        </div>
    </div>
</div>